import { TariffTypeVerification, TariffVerificationTypeEnum } from '@src/core/buyerApiClient';

export interface TariffVerificationFieldsProps {
  tariffTypeId: string;
  quantity: number;
  tariffTypePosition?: number | null;
}

export interface ProductAdderTariffVerificationFieldProps {
  tariffTypeVerification: TariffTypeVerification;
  tariffUnitIndex: number;
  initialValue: string;
  getFieldError: (verificationId: string) => boolean;
  getCartTariffVerificationError: () => boolean;
  handleValueChange: (verificationId: string, value: string) => void;
}

export const RENDERABLE_VERIFICATION_TYPES = [
  TariffVerificationTypeEnum.Date,
  TariffVerificationTypeEnum.Document,
] as const;
